import React from "react";
import { useState, useEffect } from "react";
import Exclamation from "../../../../assets/icons/Exclamation";
import {
  Container,
  Header,
  Footer,
  Label,
  Reminder,
  ReText,
  Empty,
  DivIcon,
} from "./styles";
import Input from "../../../../components/general/Input";
import Button from "../../../../components/general/Button";
import Close from "../../../../assets/icons/Close";
import Modal from "../../../../components/general/Modal";
import { useDispatch, useSelector } from "react-redux";
import { handleAddModel } from "../../../../state/flows/actions";

import { getAllFlowsTitleNames } from "../../../../state/flows/selectors";
import { toastAlert } from "../../../../components/Toastify/index";

import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import ReactLoading from "react-loading";

const SaveNewVersion = ({
  main,
  loadflow,
  isOpen,
  onClose,
  selector = "#root",
  className = "nodrag",
  user,
  elements,
  title,
}) => {
  const [projectTitle, setProjectTitle] = useState("");
  const dispatch = useDispatch();
  const allflowsTitles = useSelector((state) => getAllFlowsTitleNames(state));
  const { promiseInProgress } = usePromiseTracker({ area: "new-version" });

  useEffect(() => {
    setProjectTitle(title);
  }, [title]);

  const handleSaveModelFlow = () => {
    let newElements = JSON.parse(JSON.stringify(elements));

    newElements.forEach(function (v) {
      delete v._id;
    });

    const newFlow = {
      title: projectTitle,
      type: "version",
      tenantId: !user.tenantId ? user?._id : user.tenantId,
      parentId: main._id,
    };
    trackPromise(
      dispatch(
        handleAddModel({
          flow: newFlow,
          elements: newElements,
        }),
      )
        .then((res) => {
          const flow = res.payload.flow;
          loadflow(flow);
          toastAlert({ msg: `Versão  '${flow.title}'  CRIADA com Sucesso!` });
          onClose();
        })
        .catch((error) => {
          onClose();
          console.log(error);
          toastAlert({
            msg: `Ocorreu um ERRO ao CRIAR a versão de fluxo. {status: ${error?.code}}`,
            isError: true,
          });
        }),
      "new-version",
    );
  };
  function VersionException(errorMsg) {
    this.message = `Error Exception: ${errorMsg}`;
    toastAlert({ msg: errorMsg, isError: true });
  }

  const handleValidation = () => {
    try {
      const findNameVersion = allflowsTitles.find(
        (item) => item.title === projectTitle,
      );

      if (findNameVersion) {
        throw new VersionException(
          `o fluxo: "${projectTitle}" já foi cadastrado!`,
        );
      } else {
        handleSaveModelFlow();
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <Header>
          <Label>Salvar nova versão de fluxo</Label>
          <Reminder>
            <Exclamation style={{ height: "1.3125rem", width: "1.3125rem" }} />
            <ReText>
              Lembrete: Salvando como novo modelo não sobrescreve e deleta seus
              modelos anteriores.
            </ReText>
          </Reminder>
          <Empty />
        </Header>
        {!promiseInProgress ? (
          <>
            <Input
              style={{
                width: "23.75rem",
                paddingLeft: "1.875rem",
              }}
              value={projectTitle}
              setValue={(e) => {
                setProjectTitle(e);
              }}
              label="Nome da Versão"
              placeholder="Ex. Review 2.0"
              type="text"
            />
            <Footer>
              <Button
                outline
                content="Cancelar"
                width={"11.3125rem"}
                height={"2.625rem"}
                onClick={onClose}
              />
              <Button
                disabled={projectTitle?.length === 0}
                content="Salvar"
                width={"11.3125rem"}
                height={"2.625rem"}
                onClick={handleValidation}
              />
            </Footer>
          </>
        ) : (
          <div
            style={{
              margin: "0 auto",
              padding: "2rem",
            }}
          >
            <ReactLoading type="bars" color="#118052" />
          </div>
        )}

        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};

export default SaveNewVersion;
